import { GeneralFullPageRoutes } from "./generalFIullPageRoutes";

export const FullPageRoutes = [...GeneralFullPageRoutes];
